import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppState, useAppStateSelector, useActions } from "@nosto/preact"
import { productImagePlaceholder } from "../../helpers"
import { useEffect, useState } from "preact/hooks";
import SubmitButton from "../elements/SubmitButton"
import { ProductV2 as Product } from "../"
import { IconChevronRight } from "../icons"

const Keyword = ({ hit }) => {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    className="keyword-highlight"
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

const KeywordInCategory = ({ category, children }) => {
    return (
        <span className="keyword-in-category">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span className="keyword-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}

export default function SearchResults({ topSearches }) {

    const { updateSearch } = useActions()
    const queryData = useAppStateSelector(state => {
        //console.log('queryData', state)
        return {
            products: state.response.products,
            keywords: state.response.keywords,
            query: state.query,
            ...state
        }
    })
    const { loading } = useAppState()
    const { 
        products, 
        keywords,
    } = queryData
    const [activeKeyword, setActiveKeyword] = useState(null)
    const [hitsProducts, setHitsProducts] = useState([])
    const [hitsKeywords, setHitsKeywords] = useState([])

    //console.log('queryData', loading, queryData)

    useEffect(() => {
        if (!queryData) return

        if (products && products.hits) setHitsProducts(products.hits)
        
        if (topSearches) {
            setHitsKeywords(topSearches)    
        } else {
            if (!(queryData.query.options && 
                queryData.query.options.hasOwnProperty('isSuggestion') && 
                queryData.query.options.isSuggestion)) {
                if (keywords && keywords.hits) {
                    setHitsKeywords(keywords.hits);
                }
            }
        }
    }, [queryData])

    useEffect(() => {
        setActiveKeyword(() => {
            if (hitsKeywords.length == 0) return;
            return hitsKeywords.find(keyword => keyword.keyword == queryData.query.query) 
        })
    }, [queryData, hitsKeywords])


    return (
        <div className={`auto-complete ${topSearches ? 'top-searches' : 'results'}`}>
            <div className="flex align-items-start">
                <div className={`one-third keywords-list flex-1`}>
                    {topSearches && <div className="small-label">Top searches</div>}
                    {hitsKeywords.length > 0 ?
                        <Keywords
                            hits={hitsKeywords}
                            elementComponent={({ hit, keywordComponent, filter}) => 
                                <AutocompleteElement 
                                    as="a"
                                    link="#"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        if (hit._redirect && hit._redirect.indexOf('/pages') > -1) {
                                            window.location.href = hit._redirect
                                        } else {
                                            updateSearch({ query: hit.keyword, options: { isSuggestion: true} })
                                        }
                                    }}
                                    hit={hit} 
                                    filter={filter} 
                                    className={`keyword-autocomplete-element block ${activeKeyword && activeKeyword.keyword == hit.keyword ? 'active' : ''}`}>
                                    {keywordComponent}
                                </AutocompleteElement>
                            }
                            keywordComponent={Keyword}
                            keywordInCategoryComponent={KeywordInCategory} 
                        /> 
                        : 
                        <a href={`/search?q=${queryData.query.query}`} class="autocomplete-query">
                            <AutocompleteElement className="">
                                {queryData.query.query}
                            </AutocompleteElement>
                        </a>
                    }
                </div>
                {hitsProducts.length > 0 ? 
                    <div className="seven-tenths">
                        <div className="suggestions-results">
                            <div className="small-label">Products Suggestions</div>
                            <div className="suggestions-wrap grid">
                                {hitsProducts.map((hit, index) => (
                                    <Product product={hit} key={`product-${hit.productId || index}`} type="search" />
                                ))}
                            </div>
                            <div className={`autocomplete-submit flex justify-content-end`}>
                                <a href={`/search?q=${queryData?.query?.query}`} className="link">
                                    {`See ${products?.total} results for "${queryData?.query?.query}"`}
                                    <IconChevronRight />
                                </a>
                            </div>
                        </div>
                    </div>
                    :
                    !loading && activeKeyword && <div className="seven-tenths">
                        <div className="suggestions-results">
                            <div className="no-suggestions">
                                <p>We could not find any products</p>
                                <a href={activeKeyword._redirect}>Try this products instead</a> 
                            </div>
                        </div>
                    </div>
                    
                }
            </div>
        </div>
    )
}